import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TK = "jg_client_token";
const Ctx = createContext(null);

export const useClientAuth = () => useContext(Ctx);

export function ClientAuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem(TK) || "");
  const [user, setUser] = useState(null); // null = checking, false = signed out, object = signed in

  useEffect(() => {
    if (!token) {
      setUser(false);
      return;
    }
    axios
      .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem(TK);
        setToken("");
        setUser(false);
      });
  }, [token]);

  const persist = (t, u) => {
    localStorage.setItem(TK, t);
    setToken(t);
    setUser(u);
  };

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    persist(data.token, data.user);
  };

  const register = async (name, email, password) => {
    const { data } = await axios.post(`${API}/auth/register`, { name, email, password });
    persist(data.token, data.user);
  };

  const logout = () => {
    localStorage.removeItem(TK);
    setToken("");
    setUser(false);
  };

  return <Ctx.Provider value={{ token, user, login, register, logout }}>{children}</Ctx.Provider>;
}
